var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 64,
    viewBox: "0 0 307 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9264 0L37.0891 22.8376L32.7575 16.6838L44.3986 0H38.0366L29.6442 12.1709L21.2518 0H14.8898L26.3955 16.6838L22.1993 22.8376L6.36199 0H0L22.1993 32L29.6442 21.1966L37.0891 32L59.153 0H52.9264Z",
    fill: "#0A9A90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1993 32L0 64H6.36199L22.1993 41.1624L26.3955 47.3162L14.8898 64H21.2518L29.6442 51.8291L38.0366 64H44.3986L32.7575 47.3162L37.0891 41.1624L52.9264 64H59.153L37.0891 32L29.6442 42.6667L22.1993 32Z",
    fill: "#585757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.071 41.0256H106.8L97.731 12.8547H93.1288L84.0595 41.0256H83.7888L75.261 12.8547H68.0869L80.2694 51.1453H86.7668L95.1592 25.4359H95.4299L103.822 51.1453H110.32L122.502 12.8547H115.599L107.071 41.0256Z",
    fill: "#0A9A90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.392 34.0513H153.635V28.1709H137.392V18.735H161.757V12.8547H130.895V51.1453H163.111V45.265H137.392V34.0513Z",
    fill: "#0A9A90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195.056 37.4701H194.921L180.031 12.8547H173.398V51.1453H179.625V25.0256H179.896L194.244 48.6838H195.191L209.54 25.0256H209.81V51.1453H216.308V12.8547H209.946L195.056 37.4701Z",
    fill: "#585757"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M234.852 34.0513H251.096V28.1709H234.852V18.735H259.217V12.8547H228.355V51.1453H260.571V45.265H234.852V34.0513Z",
    fill: "#585757"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M291.298 31.1795L306.188 12.8547H298.337L287.373 26.8034L276.95 12.8547H268.557L283.176 31.453L266.933 51.1453H274.919L286.966 35.8291L298.608 51.1453H307L291.298 31.1795Z",
    fill: "#585757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b8a2271a3f844cc7058fdfe1eaa2eb97.svg";
export { ForwardRef as ReactComponent };